export const isAssignableTaskUser = (users, assignedTo) => !!assignedTo && users[assignedTo]?.isEnabled === true;

export const isTaskAssignmentValid = (formValues, users, allowedRoles) => {
    if (formValues.category === 'TODO') return true;
    if (formValues.assigneeType === 'ROLE') return allowedRoles.includes(formValues.assignedTo);
    if (formValues.assigneeType === 'USER') return isAssignableTaskUser(users, formValues.assignedTo);
    return false;
};

export const getInitialTaskAssignment = (task, users) => {
    const assigneeType = task.assignedToRole ? 'ROLE' : (task.assignedTo ? 'USER' : '');
    const requiresReplacement = assigneeType === 'USER' && task.status !== 'DONE'
        && task.category !== 'TODO' && !isAssignableTaskUser(users, task.assignedTo);
    return {assigneeType, assignedTo: requiresReplacement ? '' : (task.assignedTo || '')};
};

export const getPreviousTaskAssignee = (task, users) => (
    [users[task.assignedTo]?.firstName, users[task.assignedTo]?.lastName].filter(Boolean).join(' ').trim()
    || task.assignedToUser?.trim()
    || task.assignedTo
);
